import { Controller } from "@hotwired/stimulus"
import { CHANGE, KEY, canKeep, pin, readBench, unpin } from "../lib/bench_store"

// "Add to my workbench" on a tool's page. It puts the tool on the owner's workbench (starting one if there isn't
// one yet) or takes it off, and once it's on, the way to the workbench shows beside it. It stays hidden without
// JavaScript, and when the browser won't keep anything, because then the tool would be gone on the next visit.
export default class extends Controller {
  static targets = ["button", "label", "open"]
  static values = { slug: String }

  connect() {
    if (!canKeep()) return
    this.update = this.update.bind(this)
    this.other = (event) => event.key === KEY && this.update()
    this.element.hidden = false
    this.update()
    window.addEventListener(CHANGE, this.update)
    window.addEventListener("storage", this.other)
  }

  disconnect() {
    if (!this.update) return
    window.removeEventListener(CHANGE, this.update)
    window.removeEventListener("storage", this.other)
  }

  toggle() {
    if (this.pinned()) unpin(this.slugValue)
    else pin(this.slugValue)
  }

  pinned() {
    return !!readBench()?.pins.includes(this.slugValue)
  }

  update() {
    const on = this.pinned()
    this.buttonTarget.setAttribute("aria-pressed", on)
    this.buttonTarget.classList.toggle("is-on", on)
    this.labelTarget.textContent = on ? "On my workbench" : "Add to my workbench"
    if (this.hasOpenTarget) this.openTarget.hidden = !on
  }
}
